import { Divider, Typography, Chip, Skeleton, Paper, IconButton, TextField, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { createSearchParams, useSearchParams } from 'react-router-dom';
import { ImageItem } from '../components/Cards/Types';
import Tag from '../components/Tag/Tag';
import { ISortingFilters, TagItem } from '../components/Tag/types';
import { convertTagsToArray, createSearchParamsFormat, eliminateOjectNotTruthyValues, getLocation3CategoriesTreeWithCorrespondingChildren, GetSortOrder, showOnlySelectedOptions, splitStringByDashAndCapitalizeFirstLetterOfEachWord, transformGreekToEnglish } from '../lib/helperFuncs';
import LinkButton from '../components/Buttons/LinkButton';
import FilterComponentV2 from '../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import HttpService from '../services/HttpService';
import UserService from '../services/UserService';
import CardGrid from '../components/CardGrid';
import Theme from '../Themes/main.theme';
import { Permissions } from '../lib/permissions';
import GMapsPlaceMarker from '../components/Maps/GMapsPlaceMarker';
import { ApiUsability, AppleTitleNamingKeys, ILevel3 } from '../lib/generalTypes';
import i18n from '../i18n';
import { IGMapImage } from '../components/Maps/types';
import { PhotoCamera } from '@mui/icons-material';
import { useApiState } from '../hooks/useApiState';
import { useFromAccessLogic } from '../hooks/useFromAccessLogic';
import { getPopularCategories } from '../lib/fetchers';
interface Ilevels {
  key: string, value: number
}

const initialValues1 = {
  free_text: '',
  level1: '',
  level2: '',
  level3: '',
  regions: ''
};

const ITEMS_PER_PAGE = 16;

const ResultsLocations = () => {

  const [omekaResults, setOmekaResults] = useState<ImageItem[]>([]);
  const [sortBy, setSortBy] = React.useState<string>('1');
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLoadingPhotoSearch, setIsLoadingPhotoSearch] = useState<boolean>(false);
  const [favoriteError, setFavoriteError] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);

  const [textfieldValue, setTextfieldValue] = useState('');
  const { availableForms, isLoading: isFormPublishedLoading } =
    useFromAccessLogic(AppleTitleNamingKeys.LocationRegister);

  const [geoData, setGeoData] = useState<IGMapImage[]>([]);
  

  const [selectedTags, setSelectedTags] = React.useState<TagItem[]>([]);

  const [initialValues, setInitialValues] = useState(initialValues1);
  const [searchParams, setSearchParams] = useSearchParams();

  const [level1Options, setlevel1Options] = useState([]);
  const [level2Options, setlevel2Options] = useState([]);
  const [level3Options, setlevel3Options] = useState<ILevel3[]>([]);
  const [regions, setRegions] = useState([]);
  const [selectedThematiki, setSelectedThematiki] = useState<any[]>([]);

  const [popularCategories, setPopularCategories] = useState<any[]>([]);
  const matchesXSbreakpoint = useMediaQuery('(max-width:768px)');


  const fetchCategories = async () => {
    const data = await getPopularCategories();
    setPopularCategories(data);
  };


  useEffect(() => {
    fetchCategories();
  }, []);


  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();

  const { apiEnabled, loadingApi } = useApiState(ApiUsability.Google_Maps, true);

  const sortingItems: ISortingFilters[] = [{
    id: '1',
    refValue: 'dcterms:title',
    sortOrder: 'asc',
    label: t('Αλφαβητικά')
  }, {
    id: '2',
    refValue: 'locations:locationsCategory',
    sortOrder: 'asc',
    label: t('Κατηγορία'),
  },
  {
    id: '3',
    refValue: 'o:created',
    sortOrder: 'desc',
    label: t('Νεότερης Καταχώρισης'),
  },
  {
    id: '4',
    refValue: 'locations:region',
    sortOrder: 'asc',
    label: t('Περιφερειακή Ενότητα'),
  }];

  document.title = t('Αναζήτηση Τοποθεσιών');

  const handleTagChange = (selectedTagIds: any) => {
    if (selectedTagIds.length === 0) {
      setSelectedTags([]);
      searchParams.delete('tags');
    } else {
      setSelectedTags([...selectedTagIds]);
      const _x = selectedTagIds.map((tag: TagItem) => tag.key);
      const x = eliminateOjectNotTruthyValues({ tags: _x });
      searchParams.set('tags', x.tags);
    }
    setSearchParams(searchParams);
  };

  const handleChipTagDelete = (chipToDelete: TagItem) => {
    const index = selectedTags.indexOf(chipToDelete);
    const _selectedTags = selectedTags;
    _selectedTags.splice(index, 1);

    setSelectedTags(_selectedTags);

    const y = eliminateOjectNotTruthyValues({ tags: _selectedTags.map((tag) => tag.key) });
    if (y.tags) {
      searchParams.set('tags', y.tags || '');
    } else {
      searchParams.delete('tags');
    }
    setSearchParams(searchParams);
  };

  const clearTagsByPhotoSearch = () => {
    // remove all entries

    searchParams.delete('regions');
    searchParams.delete('level1');
    searchParams.delete('level2');
    searchParams.delete('level3');
    searchParams.delete('free_text');
    searchParams.delete('photo_tags');
    searchParams.delete('is_public');
    searchParams.delete('crm');
    searchParams.delete('order');
    searchParams.delete('page');
    searchParams.delete('page_length');

    setSearchParams(searchParams);


    if (selectedTags.length > 0) {
      handleTagChange([]);
      setTextfieldValue('');
    }
  };

  const shouldDisplayFavoriteIcon = UserService.isAuthenticated() &&
    UserService.hasRole([Permissions.PermissionExternalLocationFavoritesUpdateMy]);

  const searchByPhoto = async (e: any) => {

    if (!e.target.files) {
      return;
    }

    const file = e.target.files[0];
    setTextfieldValue(file.name);

    const formData = new FormData();
    formData.append('file', file);

    try {
      setIsLoadingPhotoSearch(true);
      const response = await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/locations/url`, formData);
      handleTagChange(response.data);
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.'), { variant: 'error' });
    }
    setIsLoadingPhotoSearch(false);
  };


  const filterFields = (
    level1Options: Ilevels[],
    level2Options: Ilevels[],
    level3Options: ILevel3[],
    regions: Ilevels[],
    // eslint-disable-next-line max-params
  ) => {


    const fullScreen = [
      [{
        control: 'input',
        name: 'free_text',
        type: 'search',
        placeholder: t('Πληκτρολογήστε'),
        filtersDesign: true,
        fullWidth: true,
      },
      ],
      [
        {
          control: 'autocomplete',
          label: t('Περιφέρειες/Δήμοι'),
          name: 'regions',
          id: 'regions',
          filtersDesign: true,
          disabled: searchParams.get('locked')?.includes('regions'),
          options: regions
        },
        {
          control: 'autocomplete',
          label: t('Θεματική Ενότητα'),
          name: 'level1',
          filtersDesign: true,
          options: level1Options,
          selectedItem: (selectedValues: ILevel3[]) => setSelectedThematiki(selectedValues),
        },
        {
          control: 'autocomplete',
          label: t('Κατηγορία Τοποθεσίας'),
          name: 'level2',
          filtersDesign: true,
          options: level2Options,
          groupByElement: 'parent'
        },
        {
          control: 'autocomplete',
          label: t('Επιπλέον Φίλτρα Κτιρίου'),
          name: 'level3',
          filtersDesign: true,
          groupByElement: 'parent',
          hidden: showOnlySelectedOptions(selectedThematiki, level3Options).length > 0
            ? false
            : true,
          options: showOnlySelectedOptions(selectedThematiki, level3Options),
        }
      ],
      <Box key='search-by-photo'>
        {UserService.isAuthenticated() && <TextField
          value={textfieldValue}
          label={t('Αναζήτηση με Φωτογραφία')}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& > fieldset': {
                borderRadius: '24px'
              }
            },
            width: '32.5%',
            minWidth: 280,
          }}
          InputProps={{
            readOnly: true,
            endAdornment: <IconButton component='label'>
              <input hidden
                onChange={searchByPhoto}
                accept='image/*'
                type='file' />
              <PhotoCamera />
            </IconButton>
          }}
        />}
      </Box>
    ];

    const mobileFilter = [
      [{
        control: 'input',
        name: 'free_text',
        type: 'search',
        placeholder: t('Πληκτρολογήστε'),
        filtersDesign: true,
        fullWidth: true,
      }],
      [{
        control: 'autocomplete',
        label: t('Περιφέρειες/Δήμοι'),
        name: 'regions',
        id: 'regions',
        filtersDesign: true,
        disabled: searchParams.get('locked')?.includes('regions'),
        options: regions
      }],
      [{
        control: 'autocomplete',
        label: t('Θεματική Ενότητα'),
        name: 'level1',
        filtersDesign: true,
        options: level1Options,
        selectedItem: (selectedValues: ILevel3[]) => setSelectedThematiki(selectedValues),
      }],
      [{
        control: 'autocomplete',
        label: t('Κατηγορία Τοποθεσίας'),
        name: 'level2',
        filtersDesign: true,
        options: level2Options,
        groupByElement: 'parent'
      }],
      [{
        control: 'autocomplete',
        label: t('Επιπλέον Φίλτρα Κτιρίου'),
        name: 'level3',
        filtersDesign: true,
        groupByElement: 'parent',
        hidden: showOnlySelectedOptions(selectedThematiki, level3Options).length > 0
          ? false
          : true,
        options: showOnlySelectedOptions(selectedThematiki, level3Options),
      }]
      ,
      <Box key='search-by-photo'>
        {UserService.isAuthenticated() && <TextField
          value={textfieldValue}
          label={t('Αναζήτηση με Φωτογραφία')}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& > fieldset': {
                borderRadius: '24px'
              }
            },
            width: '32.5%',
            minWidth: 280,
          }}
          InputProps={{
            readOnly: true,
            endAdornment: <IconButton component='label'>
              <input hidden
                onChange={searchByPhoto}
                accept='image/*'
                type='file' />
              <PhotoCamera />
            </IconButton>
          }}
        />}
      </Box>
    ];
    

    return matchesXSbreakpoint
      ? mobileFilter
      : fullScreen;

  };


  const getOmekaResults = async () => {
    const link = searchParams.toString() && `&${searchParams.toString()}`;
    const filterParameters = sortingItems?.find((x: any) => x.id === sortBy);
    const sortingParams = createSearchParams(
      {
        ...(!searchParams.has('sort_by') &&
        {
          sort_by: `${filterParameters?.refValue}`
        }),
        ...(!searchParams.has('sort_order') && {
          sort_order: `${filterParameters?.sortOrder}`
        }),
        ...(!searchParams.has('page') && {
          page: `${selectedPage}`
        }),
        ...(!searchParams.has('per_page') && {
          per_page: `${ITEMS_PER_PAGE}`
        })
      })
      .toString();
    setIsLoading(true);
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations?is_public=1&${sortingParams}&${link}&crm`, {withCredentials: true});
    const response_ids = resp.data.records.map((x: any) => x['o:id']);

    if (UserService.isAuthenticated()) {
      const resp_favorites = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/favorites?location_ids=${response_ids}`);
      const favorites = resp_favorites.data.filter((x: any) =>
        x.is_favorite === true).map((x: any) => {
        return {
          is_favorite: x.is_favorite,
          id: x.id
        };
      });

      const updatedRecords = resp.data.records.map((item: any) => {
        const favorite = favorites.find((fav: any) => fav.id === item['o:id']);
        if (favorite) {
          return {
            ...item,
            is_favorite: favorite.is_favorite,
            id: favorite.id,
          };
        }
        return item;
      });

      resp.data.records = updatedRecords;
    }
    setTotalPages(resp.data.totalResults);


    const results: ImageItem[] = resp.data.records.map((x: any) => {
      return {
        id: x['o:id'],
        title: x['o:title'],
        img: x.thumbnail_display_urls.large,
        subtitle: x?.['locations:region']?.[0]?.['@value'],
        tags: i18n.language === 'en'
          ? convertTagsToArray(x?.['locations:locationsKeyWords']?.[0]?.['@value'] || [])
          : [...convertTagsToArray(x?.['locations:locationsKeyWords']?.[0]?.['@value']) || [], ...convertTagsToArray(x?.['locations:locationsKeyWords_gr']?.[0]?.['@value']) || []],
        type_of_owner: x?.['locations:type_of_owner']?.[0]?.['@value'],
        displayFavorite: shouldDisplayFavoriteIcon,
        alwayShowBanner: matchesXSbreakpoint
          ? true
          : false,
        redirect: 'location/details',
        favorite: x.is_favorite,
        lat: Number(x?.['locations:latitude']?.[0]?.['@value']),
        lng: Number(x?.['locations:longitude']?.[0]?.['@value']),
      };
    }).filter(Boolean);
    const mapData: IGMapImage[] = results.map((x: any) => {
      return {
        id: x.id,
        title: x.title,
        img: x.img,
        lat: x.lat,
        lng: x.lng,
        redirect: 'location/details',
        favorite: x.favorite,
        displayFavorite: shouldDisplayFavoriteIcon,
      };
    });


    setGeoData(mapData);
    setOmekaResults(results);
    setIsLoading(false);
  };

  const favouriteLevel2TagsChange = (selectedTagIds: any) => {
    const ids = selectedTagIds.map((id: TagItem) => id.value);
    if (ids.length === 0) {
      searchParams.delete('level2');
    } else {
      const x = eliminateOjectNotTruthyValues({ level2: ids });
      searchParams.set('level2', x.level2);
    }
    setSearchParams(searchParams);
  };

  const constructUrlSortingFilterParams = (sortingItemId?: string, page?: number) => {
    const filterParameters = sortingItems?.find((x: any) => x.id === sortingItemId);
    for (const entry of searchParams.entries()) {
      const [param] = entry;

      if (param === 'sort_by') {
        searchParams.delete('sort_by');
        searchParams.delete('per_page');
        searchParams.delete('page');
        searchParams.delete('sort_order');
        setSearchParams(searchParams);
      }
    }
    const sortingParams = createSearchParams(
      {
        sort_by: `${filterParameters?.refValue}`,
        sort_order: `${filterParameters?.sortOrder}`,
        page: page
          ? `${page}`
          : `${selectedPage}`,
        per_page: `${ITEMS_PER_PAGE}`
      })
      .toString();
    setSearchParams(`${searchParams.toString()}&${sortingParams}`);
  };

  const handleSortingChange = (sortingItemId: string) => {
    constructUrlSortingFilterParams(sortingItemId);
    setSortBy(sortingItemId);
  };

  const handleOnPageChange = (page: number) => {
    setSelectedPage(page);
    constructUrlSortingFilterParams(sortBy, page);
  };

  const onSubmitFavorite = async (id: number, isFavorite: boolean) => {
    if (!(UserService.isAuthenticated())) {
      enqueueSnackbar(t('Πρέπει να είστε συνδεδεμένος για να προσθέσετε τοποθεσία στα αγαπημένα σας'), { variant: 'error' });
      return;
    }
    try {
      const resp = await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/locations/favorites/${id}`, { is_favorite: isFavorite });
      if (resp.status === 200) {
        const updatedResult = omekaResults.map((x: any) => {
          if (x.id === resp.data.omeka_id) {
            return {
              ...x,
              favorite: resp.data.is_favorite,
            };
          }
          return x;
        });
        setOmekaResults(updatedResult);
        setGeoData(updatedResult);
       
        if (resp.data.is_favorite === true) {
          enqueueSnackbar(`${t('Η τοποθεσία')} ${i18n.language === 'en'
            ? transformGreekToEnglish(`${resp.data.title}`)
            : resp.data.title} ${t('προστέθηκε στα αγαπημένα σας')}`, { variant: 'success' });
        } else {
          enqueueSnackbar(`${t('Η τοποθεσία')} ${i18n.language === 'en'
            ? transformGreekToEnglish(`${resp.data.title}`)
            : resp.data.title} ${t('αφαιρέθηκε από τα αγαπημένα σας')}`, { variant: 'info' });
        }
      }
    } catch (error) {
      setFavoriteError(!favoriteError);
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.'), { variant: 'error' });
    }
  };

  useEffect(() => {
    const getRegions = async () => {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/regions-search`);
      const options = resp?.data['o:terms'].map((location: any) => { return { key: t(location.key), value: location.value }; });

      setRegions(i18n.language === 'en'
        ? options.sort(GetSortOrder('key'))
        : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el'))
      );

    };
    const getLevel1Options = async () => {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level1`);
      const options = resp?.data.data?.map((location: any) => {
        return {
          key: t(location['o:title']),
          value: location['o:id']
        };
      });
      setlevel1Options(i18n.language === 'en'
        ? options.sort(GetSortOrder('key'))
        : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
    };
    const getLevel2Options = async () => {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level2`);
      const options = resp?.data?.data?.map((location: any) => {
        const x = location?.['dcterms:relation'];
        if (!x) return;
        return {
          key: t(location?.['o:title']),
          value: location?.['o:id'],
          parent: t(x[0].display_title)
        };
      }).filter((value: any) => value);
      setlevel2Options(i18n.language === 'en'
        ? options.sort(GetSortOrder('parent'))
        : options.sort((a: any, b: any) => a.parent.localeCompare(b.parent, 'el')));
    };
    const getLevel3Options = async () => {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/level3`);
      const options = getLocation3CategoriesTreeWithCorrespondingChildren(resp?.data.data);
      const options3 = options.map((option: any) => {
        return option.children.map((child: any) => {
          return {
            level1Id: option.level1Id,
            level1Title: option.level1Title,
            key: t(child.title),
            value: child.id,
            parent: t(option.title)
          };
        });
      }).flat();
      setlevel3Options(i18n.language === 'en'
        ? options3.sort(GetSortOrder('parent'))
        : options3.sort((a: any, b: any) => a.parent.localeCompare(b.parent, 'el')));
    };
    Promise.all([
      getRegions(),
      getLevel1Options(),
      getLevel2Options(),
      getLevel3Options()
    ]);
  }, []);

  useEffect(() => {
    let _params = { ...initialValues1 };
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (searchParams.has(param) && param in initialValues1) {
        if (param === 'free_text') {
          _params = { ..._params, [param]: value };
        } else {
          const _x = value.split(',').map((valueOfParam: any) => {
            return {
              key: valueOfParam,
              value: valueOfParam
            };
          });
          _params = { ..._params, [param]: _x };
        }
      }
    }

    setInitialValues({ ..._params });
    getOmekaResults();

  }, [searchParams, favoriteError]);

  // useEffect for initialValues of filters & tags & sorting based on searchParams
  useEffect(() => {

    let _params = { ...initialValues };
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (param === 'regions') { // we need this handling cause wordpress is not able to capitalize the first letter of the region
        const x = value.split(',');
        const _x = x.map((valueOfParam: any) => {

          return {
            key: splitStringByDashAndCapitalizeFirstLetterOfEachWord(valueOfParam),
            value: splitStringByDashAndCapitalizeFirstLetterOfEachWord(valueOfParam)
          };
        });
        _params = { ..._params, [param as any]: _x };

      }
      else if (param === 'free_text') {
        _params = { ..._params, [param]: value };
      }
      else if (param === 'tags') {
        const x = value.split(',');
        const _x = x.map((valueOfParam: any) => {
          return {
            key: valueOfParam,
            value: 79
          };
        });
        setSelectedTags(_x);
      } else if (param === 'sort_by') {
        const sort = sortingItems.find(item => item.refValue === value);
        setSortBy(sort?.id || '1');
      } else if (param === 'page') {
        setSelectedPage(Number(value));
      } else {
        const x = value.split(',');
        const _x = x.map((valueOfParam: any) => {
          return {
            key: valueOfParam,
            value: valueOfParam
          };
        });

        _params = { ..._params, [param]: _x };
      }
    }

    setInitialValues({ ..._params });
  }, []);

  const onSubmit = (values: any) => {
    setSelectedPage(1);
    const x = createSearchParamsFormat({...values});
    searchParams.delete('page');
    Object.keys(initialValues).map((value) => {
      searchParams.delete(value);
      setSearchParams(searchParams);
    });
    
    setSearchParams(`${searchParams.toString()}&${createSearchParams(x).toString()}`);
  };

  const BuildPreSelectedTags = (url: any) => {
    for (const entry of url) {
      const [param, value] = entry;
      if (param === 'level2') {
        const _x = value.split(',').map((valueOfParam: any) => {
          return level2Options.find((option: any) => option.value === Number(valueOfParam));
        });
        return _x;
      }

    }
  };

  return (
    <>
      <Box display='flex' justifyContent='flex-start'>
        <Box id='container' width='100%'>
          {(!isFormPublishedLoading && availableForms.is_published) 
            ? <Box display='flex' justifyContent='flex-end'
              mr={1} mb={5}>
              <LinkButton link='/location/new' variant='contained'
                tooltipTitle={
                  !UserService.hasRole([
                    Permissions.PermissionExternalLocationApplicationCreateMy
                  ])
                    ? t('Επιλέξτε Είσοδο στο Σύστημα μέσω πιστοποίησης από την ΑΑΔΕ για να μπορέσετε να καταχωρίσετε μια τοποθεσία.')
                    : ''}
                disabled={!UserService.hasRole(
                  [Permissions.PermissionExternalLocationApplicationCreateMy])}
                sx={{ borderRadius: '24px' }}>
                {t('Καταχώριση Ιδιοκτησίας')}
              </LinkButton>
            </Box>
            : null}
          <FilterComponentV2
            title={
              <Typography variant='h2' sx={{ mt: 3 }}
                color={Theme.labelColor?.main}>
                {t('Τοποθεσίες')}
              </Typography>
            }
            changeFilters={(values: any) => onSubmit(values)}
            resetFilters={true}
            resetFiltersTo={initialValues1}
            initialValues={initialValues}
            onResetFunction={() => clearTagsByPhotoSearch()}
            filterFields={filterFields(level1Options, level2Options, level3Options, regions)}
          />
          {selectedTags.length > 0 ?
            <Box display='flex'
              justifyContent='flex-start' 
              mt={4}>
              <Box>
                {selectedTags.map(x => {
                  return (
                    <>
                      <Chip sx={{ mr: 1, mb: 1}}
                        label={t(x.key)}
                        onDelete={() => handleChipTagDelete(x)}
                      />
                    </>
                  );
                })
                }
              </Box>
            </Box>
            : null
          }
          <Divider sx={{ my: 3 }} />
          <Box display='flex'
            justifyContent='space-between'>
            {isLoading || isLoadingPhotoSearch
              ? <Skeleton variant='rectangular' sx={{ mb: 2, borderRadius: '25px', width: '65%', minHeight: '40px' }} />
              : <Box display='flex'
                justifyContent='space-between'>
                <Tag
                  limitTags={9}
                  tagItems={popularCategories}
                  selectedTags={BuildPreSelectedTags(searchParams)}
                  onChange={(values) => favouriteLevel2TagsChange(values)} />
              </Box>
            }

          </Box>
          <CardGrid
            grid={{
              gridData: omekaResults,
              onTagClick: handleTagChange,
              onSubmitFavorite: onSubmitFavorite,
              selectedTags: selectedTags,

            }}
            isLoading={isLoading || isLoadingPhotoSearch}
            pagination={{
              serverSidePagination: false,
              itemsPerPage: ITEMS_PER_PAGE,
              totalResults: totalPages,
              selectedPage: selectedPage,
              handleOnPageChange: handleOnPageChange
            }}
            sorting={{
              clientSideSorting: false,
              handleSortingChange: handleSortingChange,
              defaultValue: sortBy,
              sortingItems: sortingItems
            }}
          />
        </Box>
      </Box>
      {(apiEnabled && !loadingApi)
        ? <Box mt={2}>
          <Paper variant='outlined'
            sx={{ height: 'fit-content', borderRadius: 4, boxShadow: 0, backgroundColor: 'transparent' }}>
            <Box m={2}>
              <GMapsPlaceMarker
                onSubmitFavorite={onSubmitFavorite}
                height='600px'
                zoom={8}
                location={geoData.map((x: any) => {
                  return {
                    id: x.id,
                    title: x.title,
                    img: x.img,
                    lat: x.lat,
                    lng: x.lng,
                    redirect: 'location/details',
                    favorite: x.favorite,
                    displayFavorite: shouldDisplayFavoriteIcon,
                  };
                })}
              />
            </Box>
          </Paper>
        </Box>
        : null
      }
    </>
  );
};

export default ResultsLocations;